import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/$projectId/_layout/bom')({
  loader: ({ params }) => {
    throw redirect({
      to: '/projects/$projectId/nomenclature/',
      params: { projectId: params.projectId },
      replace: true,
    })
  },
})
